import { render, staticRenderFns } from "./EvidenceUploadPreviousComment.vue?vue&type=template&id=231a7cee&scoped=true"
import script from "./EvidenceUploadPreviousComment.vue?vue&type=script&lang=js"
export * from "./EvidenceUploadPreviousComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231a7cee",
  null
  
)

export default component.exports